import type { AnnouncementAdminServiceDefinition } from '@zennolab_platform/data-access-notification-service-api';
import type { Client } from 'nice-grpc-web';
import { Token } from 'typedi';

export interface AuthSession {
  roles: string[];
}

export interface AuthService {
  /** Resolves null without a session; rejects on a Keycloak error. */
  check(): Promise<AuthSession | null>;
  login(): void;
  /** Starts the session check again (the Keycloak implementation reloads the page). */
  retry(): void;
  inFrame(): boolean;
  /** A valid access token; throws ClientError(UNAUTHENTICATED) when the session is gone. */
  getToken(): Promise<string>;
}

export type AnnouncementApi = Client<AnnouncementAdminServiceDefinition>;

export const AUTH = new Token<AuthService>('auth');
export const ANNOUNCEMENT_API = new Token<AnnouncementApi>('announcementApi');
